import { User } from 'firebase/auth';
import { useState, useEffect, useCallback } from 'react';
import updateCart from '~/firebase/update/updateCart';

import authAtom from '~/recoil/atom/auth';
import { useRecoilValue } from 'recoil';

import useCartId from '~/hooks/useCartId';

import * as fp from 'lodash/fp';
import { emailRegex } from '~/types/utilities';
import { PLATFORM_ID } from '~/globalVariables';
import { CartType } from '~/types/cart';

const checkEmailFn = fp.cond<string, string>([
  [fp.eq(''), fp.always('請輸入電子郵件')],
  [(v) => !emailRegex.test(v), fp.always('電子郵件不正確')],
  [fp.T, fp.always('')],
]);

export default function useEmail(defaultEmail: string = '') {
  const { cartId } = useCartId();

  const [email, setEmail] = useState<string>(defaultEmail);
  const [emailError, setEmailError] = useState('');

  const handleUpdateEmail = useCallback(
    fp.debounce(700, async (email: string, cartId: string) => {
      setEmailError(checkEmailFn(email));
      try {
        await updateCart(PLATFORM_ID, cartId, {
          email: email,
        });
      } catch (err) {
        console.error('update email error');
      }
    }),
    [setEmailError],
  );

  const handleChangeEmail = (value: string) => {
    setEmail(value);

    if (cartId) {
      handleUpdateEmail(value, cartId);
    }
  };

  useEffect(() => {
    setEmail(defaultEmail);
  }, [defaultEmail]);

  return {
    email,
    emailError,
    handleChangeEmail,
  };
}
